import axios, { AxiosRequestConfig } from "axios";
import {
  DepartmentDTO,
  AddressDTO,
  ContactDTO,
  ContactReferenceDTO
} from "../model/data.model";
import { DepartmentManagementDef } from "../model/component.model";
import { getTenantId } from "./AuthService";
import store from "../vuex/store";

export class DepartmentService {
  createDepartment(customerMbeId: string, department: DepartmentManagementDef) {
    console.assert(
      department.id === undefined,
      "New departments does not need id"
    );
    console.assert(
      department.departmentAddressId === undefined,
      "New department addresses does not need id"
    );
    console.assert(
      department.departmentContactAddressId === undefined,
      "New department contact address does not need id"
    );

    const departmentDTO = {
      tenantId: getTenantId(),
      departmentBusinessName: department.name,
      customerMBId: customerMbeId,
      defaultAssigned: true,
      address: {
        firstname: department.nameContactPersonRef,
        birthDate: "1970-01-01",
        gender: "",
        lastname: "",
        contactsReference: [
          { type: "CELLULAR", value: "" },
          { type: "EMAIL", value: department.emailContactPersonRef },
          { type: "FAX", value: department.faxContactPersonRef },
          { type: "TELEPHONE", value: department.telephoneContactPersonRef }
        ] as ContactReferenceDTO[],
        addresses: [
          {
            address: department.address,
            city: department.city,
            province: department.province,
            countryId: "IT",
            countryName: "Italy",
            state: department.state,
            zipCode: department.zipcode,
            type: "DEPARTMENT"
          }
        ] as AddressDTO[]
      } as ContactDTO
    } as DepartmentDTO;

    const config: AxiosRequestConfig = {
      method: "POST",
      url:
        store.getters.BASE_API_URL +
        "/customers/" +
        customerMbeId +
        "/departments",
      data: departmentDTO
    };
    return axios.request(config).then(res => {
      return res;
    });
  }

  updateDepartment(
    customerMbeId: string,
    department: DepartmentManagementDef,
    departmentId: number
  ) {
    const departmentDTO = {
      departmentId: departmentId,
      tenantId: getTenantId(),
      departmentBusinessName: department.name,
      customerMBId: customerMbeId,
      defaultAssigned: true,
      address: {
        id: department.departmentContactAddressId,
        firstname: department.nameContactPersonRef,
        birthDate: "1970-01-01",
        gender: "",
        lastname: "",
        contactsReference: [
          { type: "CELLULAR", value: "" },
          {
            type: "EMAIL",
            value: department.emailContactPersonRef,
            id: department.emailId
          },
          {
            type: "FAX",
            value: department.faxContactPersonRef,
            id: department.faxId
          },
          {
            type: "TELEPHONE",
            value: department.telephoneContactPersonRef,
            id: department.telephoneId
          }
        ] as ContactReferenceDTO[],
        addresses: [
          {
            id: department.departmentAddressId,
            address: department.address,
            city: department.city,
            province: department.province,
            countryId: "IT",
            countryName: "Italy",
            state: department.state,
            zipCode: department.zipcode,
            type: "DEPARTMENT"
          }
        ] as AddressDTO[]
      } as ContactDTO
    } as DepartmentDTO;

    const config: AxiosRequestConfig = {
      method: "POST",
      url:
        store.getters.BASE_API_URL +
        "/customers/" +
        customerMbeId +
        "/departments/" +
        departmentId,
      data: departmentDTO
    };
    return axios.request(config).then(res => {
      return res;
    });
  }

  deleteDepartment(customerMbeId: string, departmentId: number | undefined) {
    const config: AxiosRequestConfig = {
      method: "DELETE",
      url:
        store.getters.BASE_API_URL +
        "/customers/" +
        customerMbeId +
        "/departments/" +
        departmentId
    };
    return axios.request(config).then(res => {
      return res;
    });
  }
}
